export const DASHBOARD_URL = 'custom-dashboards'
export const DASHBOARD_EDITOR_PATH_SEGMENT = 'edit'

export const DASHBOARD_LIST_TRANSACTION_PATH = `/project/:id/${DASHBOARD_URL}`
export const DASHBOARD_DETAIL_TRANSACTION_PATH = `/project/:id/${DASHBOARD_URL}/:customDashboardId`
export const DASHBOARD_EDIT_TRANSACTION_PATH = `/project/:id/${DASHBOARD_URL}/:customDashboardId/${DASHBOARD_EDITOR_PATH_SEGMENT}`

export const SHARE_CUSTOM_DASHBOARD =
  '/project/:id/custom-dashboards/:dashboardId/shared/:token'
